/* This example requires Tailwind CSS v2.0+ */
import React, { useState } from 'react';
import './subCollectionHighlight.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../../utils/globals';
import { IBlock, IColor } from '../../../../../utils/types/contentful';
import { Button } from '../../../Elements';
import { Link } from '../../../Elements/Link';
import { Image } from '../../../Media';
import FilterService from '../../../../../services/FilterService';

export interface SubCollectionHighlightProps {
  detail: IBlock;
  color: IColor;
}

export const SubCollectionHighlight = ({
  detail,
  color,
}: SubCollectionHighlightProps) => {
  const [isHover, setIsHover] = useState(false);

  const { link, image, label } = formatContentfulComponentProps(detail);

  return (
    <Link {...link}>
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className='flex flex-col w-full items-start justify-start max-h-full'>
        <div
          className='relative mt-3 max-h-full rounded-lg overflow-hidden '
          style={{ height: '280px', width: '280px' }}>
          <div className='absolute w-full h-full pointer-events-none	 z-1 gradient-image'></div>
          <div className='scale-100	hover:scale-105 transform ease-in-out duration-700'>
            <Image
              {...image}
              objectFit='cover'
              height='100%'
              width='100%'
            />
          </div>
          <div className='flex pointer-events-none justify-between items-end px-4 absolute z-1 bottom-4 w-full'>
            <div className='hidden pr-4 lg:block overflow-hidden'>
              <Label
                type='h3'
                size='lg'
                color={{ classname: 'white' }}
                text={link?.label?.text}
                truncate
              />
            </div>
            <Button
              icon={{
                iconKey: 'HiOutlineChevronRight',
                size: 'lg',
                color: color.classname,
              }}
              type='white'
              size='lg'
            />
          </div>
        </div>
        <div className='mt-3'>
          <Label
            {...label}
            type='span'
            size='lg'
            weight='light'
            color={{ classname: isHover && 'black' }}
          />
        </div>
      </div>
    </Link>
  );
};
